<template>

  <svg
    t="1631089199617"
    class="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="5797"
    width="64"
    height="64"
  ><path d="M102.4 102.4h136.53333333v819.2H102.4V102.4z m341.33333333 204.8h136.53333334v614.4H443.73333333V307.2z m332.8 204.8h136.53333334v409.6H776.53333333V512z" p-id="5798" /></svg>


</template>

<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'JtIconChart',
} as DefineComponent
</script>